/** Domain service module: storage.js */
import { getSelectedGroupId, setSelectedGroupId } from '../http/session'
import { USER_ACCESS_LEVELS_DIC } from '../constants/definitions'
import { auth } from './auth'

class LocalStorageService {
  selectedGroup() {
    let _selectedGroup = JSON.parse(localStorage._selectedGroup || '{}')
    let _user = auth.user()
    if (_user.access_level >= USER_ACCESS_LEVELS_DIC.ADMIN.value) {
      if (isNaN(_selectedGroup?.id)) {
        return null
      }
    } else {
      let _userGroups = _user?.legal_person?.groups || []
      let _ixSelectedGroup = _userGroups.findIndex(x => x.id === _selectedGroup?.id)
      if (_ixSelectedGroup <= -1 && _userGroups.length > 0) {
        _selectedGroup = _userGroups[0]
        localStorage._selectedGroup = JSON.stringify(_selectedGroup)
      } else if (_ixSelectedGroup <= -1) {
        _selectedGroup = null
        localStorage.removeItem('_selectedGroup')
      }
      setSelectedGroupId(_selectedGroup?.id || null)
    }
    return _selectedGroup
  }

  isGroupSelected() {
    return getSelectedGroupId() != null;
  }

  selectGroup(group) {
    let _selectedGroup = group
    let _user = auth.user()
    if (_user.access_level >= USER_ACCESS_LEVELS_DIC.ADMIN.value) {
      if (_selectedGroup && _selectedGroup?.id) {
        localStorage._selectedGroup = JSON.stringify(_selectedGroup)
        setSelectedGroupId(_selectedGroup?.id || null)
      } else {
        setSelectedGroupId(null)
        localStorage.removeItem('_selectedGroup')
      }
    } else {
      let _userGroups = _user?.legal_person?.groups || []
      let _ixSelectedGroup = _userGroups.findIndex(x => x.id === _selectedGroup?.id)
      if (_ixSelectedGroup >= 0) {
        localStorage._selectedGroup = JSON.stringify(_selectedGroup)
        setSelectedGroupId(_selectedGroup?.id || null)
      }
    }
  }
}

export const storage = new LocalStorageService()
export default storage
